module.exports = __webpack_public_path__ + "img/promptPay.23295e6.png";